import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Card, CardActionArea, CardContent, Box, Typography, Stack, Chip, Button } from '@mui/material';
import { useRedirectLink } from '../services/queries';

const DashboardCard = ({ card, isInternal, setSelectedCard, onChangePassword }) => {
  const [url, setUrl] = useState('')
  const [imgError, setImgError] = useState(false);
  const { isLoading, data, error, refetch } = useRedirectLink(url);

  const handleClick = useCallback(() => {
    if (isInternal) return window.open(card.path, '_self')
      
    if (!card.is_connected) return setSelectedCard(card)
    const url = card?.url?.split('=') || ''
    return setUrl(url[1]);
    // isInternal ?
    //   window.open(card.path, '_self') :
    //   window.open(card.host, '_blank');
  }, [card.host]);

  useEffect(() => {
    if (data) {
      const formattedUrl = data?.data?.url.match(/^https?:/) ? data?.data?.url : '//' + data?.data?.url;
      window.open(formattedUrl, '_blank');
      setUrl('')
    }
  }, [data])

  // Reset error state saat card atau img_url berubah
  useEffect(() => {
    setImgError(false);
  }, [card?.img_url, card?.code])

  return (
    <Card
      sx={styles.card}
      onClick={handleClick}
    >
      <CardActionArea sx={styles.cardActionArea}>
        <CardContent sx={styles.cardContent}>
          {
            isInternal ?
              <Stack direction={'row'} alignItems={'center'} spacing={1}>
                {card.icon}
                <Typography fontWeight={600}>{card.text}</Typography>
              </Stack> :
              <img 
                src={imgError ? '/tvri.jpg' : (card.img_url || '/tvri.jpg')} 
                alt={`${card.name} Logo`} 
                style={styles.logo}
                loading="lazy"
                onError={(e) => {
                  // Fallback jika gambar gagal dimuat
                  if (!imgError && e.target.src !== '/tvri.jpg') {
                    setImgError(true);
                  }
                }}
                onLoad={() => {
                  // Reset error state jika gambar berhasil dimuat
                  if (imgError) {
                    setImgError(false);
                  }
                }}
              />
          }
          {
            !isInternal &&
            <Box textAlign="center" mt={2}>
              <Typography fontWeight="bold">{card.name}</Typography>
              {/* <Typography color="var(--primary-color)" fontSize={14}>{card.host}</Typography> */}
              <Typography
                sx={{
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  display: '-webkit-box',
                  WebkitLineClamp: '2',
                  WebkitBoxOrient: 'vertical',
                  my: 1,
                  color: 'var(--text-secondary)'
                }}
                variant="body2">
                {card.description}
              </Typography>
              <Chip
                color={card.is_connected ? 'success' : 'default'}
                size='small'
                label={card.is_connected ? 'Connected' : 'Not connected'}
              />

              {!!onChangePassword && card.is_connected && (
                <Box
                  mt={1.5}
                  onMouseDown={(e) => e.stopPropagation()}
                  onClick={(e) => e.stopPropagation()}
                >
                  <Button
                    size="small"
                    variant="outlined"
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      onChangePassword(card);
                    }}
                  >
                    Change Password
                  </Button>
                </Box>
              )}
            </Box>
          }
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

const styles = {
  card: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    cursor: 'pointer',
    backgroundColor: '#fff',
    borderRadius: '16px',
    border: '1px solid var(--border-subtle)',
    boxShadow: 'var(--shadow-card)',
    transition: 'all 0.2s ease',
    height: '100%',
    '&:hover': {
      boxShadow: '0 14px 32px rgba(15,23,42,0.12)',
      transform: 'translateY(-2px)',
      backgroundColor: '#f9fafb'
    },
  },
  cardActionArea: {
    flexGrow: 1,
  },
  cardContent: {
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  logo: {
    width: 50,
    height: 50,
    objectFit: 'contain',
    display: 'block',
  }
};

// DashboardCard.propTypes = {
//   card: PropTypes.shape({
//     name: PropTypes.string.isRequired,
//     host: PropTypes.string.isRequired,
//     description: PropTypes.string.isRequired,
//     is_active: PropTypes.bool.isRequired,
//   }).isRequired,
// };

export default React.memo(DashboardCard);
